export const modelLockedRemainingTime = ({ modelsViewer }) => modelId => {
  const modelViewer = modelsViewer.byId[modelId];
  if (!modelViewer) return;

  const lockExpirationFormatted = modelViewer.lockedUntil.split(' ');
  const addedFormatDate = [
    lockExpirationFormatted[0],
    'T',
    lockExpirationFormatted[1],
    'Z',
  ].join('');
  const formattedISODate = new Date(addedFormatDate).getTime();
  const now = new Date().getTime();
  const remainingTime = formattedISODate - now;
  return remainingTime;
};

export const checkLockStatus = ({ modelsViewer }) =>
  modelsViewer.checkLockStatus;
